import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../refeicao.module.css";
import BottomNav from "../../../components/BottomNav";
import BackIcon from "../../../components/BackIcon";
import api from "../../../services/api";
import { AuthContext } from "../../../context/AuthContext";
import ApiButton from "../../../components/ApiButton/ApiButton";

const diasSemana = [
    { id: 1, nome: "Segunda" },
    { id: 2, nome: "Terça" },
    { id: 3, nome: "Quarta" },
    { id: 4, nome: "Quinta" },
    { id: 5, nome: "Sexta" }
];

// Mesmos tipos/ícones da tela de cadastro no CoziMaxERP (Configuração · Cardápio) -
// tipcar 1/2/3.
const TIPOS_CARDAPIO = {
    1: { nome: "Normal", icone: "🍽️" },
    2: { nome: "Vegetariano", icone: "🥗" },
    3: { nome: "Balcão do Chef", icone: "👨‍🍳" },
};

// Label de exibição dos botões de tipo (Normal/Light/Chef) - "light" continua
// sendo o valor interno/código enviado à API (converterTipo -> "L"), só o
// texto mostrado ao colaborador virou "Vegetariano".
const TIPO_LABEL = { normal: "Normal", light: "Vegetariano", chef: "Chef" };

// Movido de Refeicao/index.jsx pra cá (2026-10-14) quando a tela virou uma
// escolha entre Almoço e Café da Manhã - essa página é só o fluxo de almoço,
// inalterado por fora (mesma lógica/regras de sempre), só o caminho (rota) e
// o header (agora com botão voltar, por ser subpágina) mudaram.
export default function Almoco() {

    const navigate = useNavigate();
    const { user } = useContext(AuthContext);

    const hoje = new Date().getDay();

    const converterDia = () => {
        if (hoje === 0) return 1;
        if (hoje === 6) return 1;
        return hoje;
    }

    // Agendamento da semana seguinte (pedido do usuário, 2026-08-31; refinado
    // em 2026-07-27 pra só liberar a partir das 15h): libera sexta-feira
    // (hoje === 5) a partir das 15h E continua liberado sábado/domingo
    // (hoje === 6 ou 0) - bug encontrado pelo usuário, 2026-10-24: a condição
    // só considerava "hoje É sexta", então virando sábado (ainda dentro da
    // janela "já passou das 15h de sexta") a liberação sumia de novo. Na
    // segunda-feira o ciclo já reinicia sozinho (a "semana seguinte" de
    // sábado/domingo passa a ser a "semana atual").
    const podeVerProximaSemana = (hoje === 5 && new Date().getHours() >= 15) || hoje === 6 || hoje === 0;
    const [semanaSelecionada, setSemanaSelecionada] = useState("atual"); // "atual" | "proxima"

    const [diaSelecionado, setDiaSelecionado] = useState(converterDia());
    const [tipo, setTipo] = useState("normal");
    const [prato, setPrato] = useState("");
    const [agendado, setAgendado] = useState(false);
    const [agendaSemana, setAgendaSemana] = useState([]);
    const [horaAgenda, setHoraAgenda] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [cancelado, setCancelado] = useState(false);
    const [dataCancelamento, setDataCancelamento] = useState("");
    // Cardápio do dia (Portal.cardapio) - array porque pode ter até 3 tipos cadastrados
    // pro mesmo dia (Normal/Light/Chef). Nunca era buscado de verdade antes - o card só
    // mostrava um placeholder fixo ("futuramente virá da API").
    const [cardapio, setCardapio] = useState([]);
    // Histórico de agendar/cancelar do dia selecionado (pedido do usuário,
    // 2026-08-31) - cancelar e agendar de novo hoje "some" o rastro na tela
    // porque DelRef apaga a linha de verdade; esse log vem de MicLog, que já
    // é gravado há tempo mas nunca tinha sido mostrado (ver GetLogRef).
    const [logRef, setLogRef] = useState([]);

    function podeAgendar(diaSelecionado, tipo) {

        // Semana seguinte: nenhum dia dela já "passou" nem tem prazo vencido
        // ainda (essas regras abaixo comparam com o dia/hora de HOJE, que só
        // fazem sentido dentro da semana atual) - libera todos os dias.
        if (semanaSelecionada === "proxima") return true

        // Dia já passado na semana atual - só dá pra consultar o histórico
        // dele (pedido do usuário, 2026-10-07), nunca agendar.
        if (diaSelecionado < converterDia()) return false

        const agora = new Date()

        const diaAtual = agora.getDay()

        const horaAtual = agora.getHours()

        const diaApi = diaSelecionado + 1

        // regra normal / light
        if (tipo !== "chef") {

            if (diaApi === diaAtual + 1 && horaAtual >= 8) {

                return false

            }

        }

        // regra balcão chef - fecha quinta às 11h (1 dia de antecedência pra
        // cozinha se preparar). BUG CORRIGIDO 2026-10-07: "quinta" estava
        // com o valor 5, que no getDay() do JS (domingo=0...sábado=6) é
        // SEXTA, não quinta (quinta é 4) - isso fazia o prazo só travar em
        // cima da hora, na própria sexta depois das 11h, em vez de fechar
        // com um dia de antecedência como devia. Sexta inteira também
        // precisa ficar bloqueada (o prazo já passou há muito).
        if (tipo === "chef") {

            // sexta = 6 (convenção usada em diaApi, não é o getDay() do JS)
            if (diaApi === 6) {

                const quinta = 4
                const sexta = 5

                if ((diaAtual === quinta && horaAtual >= 11) || diaAtual === sexta) {

                    return false

                }

            }

        }

        return true

    }

    // Cancelamento da refeição de HOJE só até 07:59 (pedido do usuário -
    // gente estava almoçando e cancelando depois, sumindo com o registro de
    // comparecimento). Dias futuros (inclusive semana seguinte) sempre podem
    // ser cancelados - só hoje tem prazo. A trava de verdade é no backend
    // (DelRef); isto aqui só evita mostrar um botão que o servidor vai
    // recusar.
    function podeCancelar() {

        if (semanaSelecionada === "proxima") return true

        if (diaSelecionado !== converterDia()) return true

        return new Date().getHours() < 8

    }


    function converterTipo(tipo) {

        if (tipo === "normal") return "N"
        if (tipo === "light") return "L"
        if (tipo === "chef") return "C"

    }

    function obterDataDiaSemana(dia) {

        const hoje = new Date()

        const diaAtual = hoje.getDay()

        // +7 dias quando a semana seguinte está selecionada - mesma lógica
        // de sempre, só desloca uma semana inteira pra frente.
        const offsetSemana = semanaSelecionada === "proxima" ? 7 : 0

        const diff = dia - diaAtual + offsetSemana

        const data = new Date()

        data.setDate(hoje.getDate() + diff)

        return data.toLocaleDateString("pt-BR")

    }

    async function agendar() {

        try {

            const datref = obterDataDiaSemana(diaSelecionado)

            const tippra = converterTipo(tipo)

            const payload = {
                codfun: user.codfun,

                tipfun: user.tipfun,

                datref: datref,

                tippra: tippra,

                nompra: prato,

                tipref: "A"

            }

            const res = await api.post("/colaborador/agendaref", payload)

            // O backend responde 200 mesmo quando rejeita (prazo vencido, data
            // inválida etc.) - o corpo é que carrega o resultado de verdade
            // (result/msg), mesmo padrão já usado no resto da API. Sem checar
            // isso aqui, uma rejeição do servidor passava batido como sucesso.
            if (res.data?.result === "ERRO") {
                alert(res.data.msg || "Não foi possível agendar essa refeição.")
                await carregarAgenda()
                return
            }

            await carregarAgenda()
            await carregarLogRef()

        }
        catch (err) {

            console.error(err)

            alert("Erro ao agendar refeição")

        }

    }



    function diaTemAgendamento(diaFront) {

        const diaApi = diaFront + 1

        const registro = agendaSemana.find(r => r.dia === diaApi)

        if (!registro) return false

        if (registro.status === "C" && !registro.datdes) {
            return true
        }

        return false

    }



    // Dia já passado na semana atual - navegar continua liberado (pra ver o
    // histórico de agendamento/cancelamento dele), só não dá pra agendar
    // (ver podeAgendar). Antes isso travava a navegação inteira.
    function diaJaPassou(dia = diaSelecionado) {
        return semanaSelecionada === "atual" && dia < converterDia()
    }

    function selecionarDia(dia) {

        setDiaSelecionado(dia)

        verificarDia(agendaSemana, dia)

    }

    function selecionarSemana(sem) {

        if (sem === semanaSelecionada) return

        // Trava também aqui dentro (não só no disabled do botão) - segurança
        // de verdade fica por conta do backend (PostRef), mas isso evita que
        // outro caminho de código chame isto direto e ignore o cadeado.
        if (sem === "proxima" && !podeVerProximaSemana) return

        const novoDia = sem === "proxima" ? 1 : converterDia()

        setSemanaSelecionada(sem)
        setDiaSelecionado(novoDia)
        carregarAgenda(sem, novoDia)

    }

    function selecionarTipo(tipoEscolhido) {

        if (tipoEscolhido === "chef" && diaSelecionado !== 5) return;

        setTipo(tipoEscolhido);

        // Troca de prato só faz sentido no Normal - Light/Chef não têm essa opção,
        // então limpa qualquer seleção que tenha ficado de uma troca anterior.
        if (tipoEscolhido !== "normal") setPrato("");

    }


    async function cancelar() {

        try {


            if (!navigator.onLine) {
                alert("Sem internet");
                return;
            }



            const datref = obterDataDiaSemana(diaSelecionado)



            const payload = {
                codfun: user.codfun,

                tipfun: user.tipfun,

                datref: datref,

                tipref: "A"

            }


            const res = await api.post("/colaborador/delref", payload)

            // Mesmo caso de PostRef/agendar - o backend responde 200 mesmo
            // rejeitando (prazo de cancelamento vencido), quem carrega o
            // resultado de verdade é o corpo (result/msg).
            if (res.data?.result === "ERRO") {
                alert(res.data.msg || "Não foi possível cancelar essa refeição.")
                await carregarAgenda()
                return
            }

            await carregarAgenda()
            await carregarLogRef()

        }
        catch (err) {

            console.error(err)

            alert("Erro ao cancelar refeição")

        }

    }

    function verificarDia(lista, diaFront) {

        const diaApi = diaFront + 1

        const registro = lista.find(r => r.dia === diaApi)

        if (!registro) {

            setAgendado(false)
            setCancelado(false)
            setHoraAgenda("")
            setTipo("normal")
            setPrato("")
            return

        }

        // CANCELADO
        if (registro.datdes) {

            setCancelado(true)
            setAgendado(false)

            setDataCancelamento(registro.datdes)


            return

        }

        // AGENDADO
        if (registro.status === "C") {

            setAgendado(true)
            setCancelado(false)

            setHoraAgenda(registro.datins)

            if (registro.tippra === "N") setTipo("normal")
            if (registro.tippra === "L") setTipo("light")
            if (registro.tippra === "C") setTipo("chef")

            setPrato(registro.nompra);

        }
        else {

            setAgendado(false)
            setCancelado(false)

            setTipo("normal")
            setPrato("")

        }

    }

    // semana/dia são opcionais - por padrão usa o que já está selecionado
    // (é o que agendar()/cancelar() querem: só recarregar sem mudar de
    // semana/dia). selecionarSemana() passa os dois explícitos porque o
    // setState ainda não refletiu no momento da chamada.
    async function carregarAgenda(semana = semanaSelecionada, dia = diaSelecionado) {

        const semanaParam = semana === "proxima" ? 1 : 0

        const res = await api.get(`/colaborador/getref/?codfun=${user.codfun}&tipfun=${user.tipfun}&semana=${semanaParam}&tipref=A`)

        setAgendaSemana(res.data)

        verificarDia(res.data, dia)

    }

    useEffect(() => {

        if (!agendaSemana.length) return

        verificarDia(agendaSemana, diaSelecionado)

    }, [diaSelecionado])


    useEffect(() => {

        if (!navigator.onLine) {
            alert("Sem internet");
            return;
        }

        carregarAgenda()

    }, [])

    useEffect(() => {

        async function carregarCardapio() {

            try {

                // Acompanha o dia selecionado no seletor abaixo (mesma função já usada
                // pro agendamento) - não fica travado no dia de hoje. Mesmo formato
                // (DD/MM/AAAA) usado na tela de cadastro do CoziMaxERP - o backend
                // compara datcar como string exata, então o formato tem que bater.
                const dataAlvo = obterDataDiaSemana(diaSelecionado)

                const res = await api.get(`/portal/cardapio/?datcar=${encodeURIComponent(dataAlvo)}`)

                setCardapio(Array.isArray(res.data) ? res.data : [])

            }
            catch (err) {

                console.error(err)
                setCardapio([])

            }

        }

        carregarCardapio()

    }, [diaSelecionado])

    async function carregarLogRef(dia = diaSelecionado) {

        try {

            const dataAlvo = obterDataDiaSemana(dia)

            const res = await api.get(`/colaborador/logref/?codfun=${user.codfun}&tipfun=${user.tipfun}&datref=${encodeURIComponent(dataAlvo)}&tipref=A`)

            setLogRef(Array.isArray(res.data) ? res.data : [])

        }
        catch (err) {

            console.error(err)
            setLogRef([])

        }

    }

    useEffect(() => {

        carregarLogRef()

    }, [diaSelecionado, semanaSelecionada])

    return (
        <div className={styles.container}>

            {/* HEADER */}
            <div className={styles.header}>
                <button className={styles.btnVoltar} onClick={() => navigate("/refeicao")}><BackIcon /></button>
                <div className={styles.headerTexto}>
                    <h2>Almoço</h2>
                    <p>Agendamento e acompanhamento</p>
                </div>
            </div>

            {/* CARDÁPIO DO DIA */}
            <div className={styles.card}>
                <span className={styles.cardTitulo}>📋 Cardápio — {diasSemana.find(d => d.id === diaSelecionado)?.nome}</span>
                {cardapio.length > 0 ? (
                    cardapio.map(item => {
                        const info = TIPOS_CARDAPIO[item.tipcar] || { nome: "", icone: "🍽️" };
                        return (
                            <div key={item.codcar} className={styles.cardapioItem}>
                                <span className={styles.cardapioTipo}>{info.icone} {info.nome}</span>
                                <div
                                    className={styles.cardapioTexto}
                                    dangerouslySetInnerHTML={{ __html: item.descar }}
                                />
                            </div>
                        );
                    })
                ) : (
                    <p className={styles.cardapioVazio}>Cardápio não disponível no momento.</p>
                )}
            </div>

            {/* SELEÇÃO DE DIA */}
            <div className={styles.card}>
                <div className={styles.cardTituloLinha}>
                    <span className={styles.cardTitulo}>📅 Selecione o dia{semanaSelecionada === "proxima" ? " — semana seguinte" : ""}</span>
                    <span className={styles.semanaRange}>{obterDataDiaSemana(1)} – {obterDataDiaSemana(5)}</span>
                </div>

                {/* Sempre visível (pedido do usuário) - só habilita mesmo às
                    sextas-feiras a partir das 15h. A trava de verdade é no
                    backend (PostRef); isto aqui é só pra não deixar o
                    colaborador nem tentar fora do horário. */}
                <div className={styles.semanaTabs}>
                    <button
                        className={`${styles.semanaTab} ${semanaSelecionada === "atual" ? styles.semanaTabAtivo : ""}`}
                        onClick={() => selecionarSemana("atual")}
                    >
                        Esta semana
                    </button>
                    <button
                        className={`${styles.semanaTab} ${semanaSelecionada === "proxima" ? styles.semanaTabAtivo : ""}`}
                        onClick={() => selecionarSemana("proxima")}
                        disabled={!podeVerProximaSemana}
                        title={podeVerProximaSemana ? undefined : "Libera às sextas-feiras, a partir das 15h"}
                    >
                        {!podeVerProximaSemana && "🔒 "}Semana seguinte
                    </button>
                </div>

                <div className={styles.diasGrid}>
                    {diasSemana.map((d) => {
                        const temAgenda = diaTemAgendamento(d.id)
                        const passado = diaJaPassou(d.id)
                        return (
                            <button
                                key={d.id}
                                onClick={() => selecionarDia(d.id)}
                                className={`${styles.diaCard} ${diaSelecionado === d.id ? styles.diaSelecionado : ""} ${passado ? styles.diaPassado : ""}`}
                            >
                                <span className={styles.diaNome}>{d.nome.slice(0, 3).toUpperCase()}</span>
                                {temAgenda && <span className={styles.badgeAgendado}>✓</span>}
                            </button>
                        )
                    })}
                </div>
            </div>

            {/* TIPO E PRATO */}
            <div className={styles.card}>
                <span className={styles.cardTitulo}>🥗 Tipo de refeição</span>

                <div className={styles.tipoGrid}>
                    <button
                        className={`${styles.tipoBtn} ${tipo === "normal" ? styles.tipoAtivo : ""}`}
                        disabled={agendado || cancelado || diaJaPassou()}
                        onClick={() => selecionarTipo("normal")}
                    >
                        Normal
                    </button>
                    <button
                        className={`${styles.tipoBtn} ${tipo === "light" ? styles.tipoAtivo : ""}`}
                        disabled={agendado || cancelado || diaJaPassou()}
                        onClick={() => selecionarTipo("light")}
                    >
                        Vegetariano
                    </button>
                    <button
                        className={`${styles.tipoBtn} ${tipo === "chef" ? styles.tipoAtivo : ""}`}
                        disabled={agendado || cancelado || diaJaPassou()}
                        onClick={() => selecionarTipo("chef")}
                    >
                        Chef
                    </button>
                </div>

                <div className={styles.selectWrapper}>
                    <select
                        value={prato}
                        disabled={agendado || cancelado || diaJaPassou() || tipo !== "normal"}
                        onChange={(e) => setPrato(e.target.value)}
                        className={styles.select}
                    >
                        <option value="">Alteração de prato (opcional)</option>
                        <option value="OVO FRITO">OVO FRITO</option>
                        <option value="OMELETE C/ QUEIJO">OMELETE C/ QUEIJO</option>
                        <option value="OVO COZIDO">OVO COZIDO</option>
                        <option value="OMELETE C/FRIOS">OMELETE C/ FRIOS</option>
                    </select>
                </div>
            </div>

            {/* REGRAS DE HORÁRIO - pedido do usuário, 2026-10-07 (reposicionado e
                deixado mais discreto em 2026-10-08, a pedido). */}
            <div className={styles.regrasBox}>
                <strong className={styles.regrasTitulo}>Regras de agendamento:</strong>
                <ul className={styles.regrasLista}>
                    <li>Almoço: Agendamento ou cancelamento até <strong>7h59</strong> do dia da refeição.</li>
                    <li>Balcão do Chef de sexta: Agendamento ou cancelamento até <strong>quinta-feira, às 11h</strong>.</li>
                    <li>Almoço da semana seguinte: Agendamento a partir de <strong>sexta-feira, às 15h</strong>.</li>
                </ul>
            </div>

            {/* STATUS / AÇÃO */}
            {cancelado ? (
                <div className={styles.canceladoBox}>
                    ❌ Cancelado em {dataCancelamento}
                </div>
            ) : agendado ? (
                <div className={styles.card}>
                    <div className={styles.statusBox}>
                        <span className={styles.statusIcone}>✅</span>
                        <div className={styles.statusTexto}>
                            <strong>Refeição agendada</strong>
                            <span>{horaAgenda}</span>
                        </div>
                    </div>
                    {podeCancelar() ? (
                        <ApiButton className={styles.btnCancelar} onClick={cancelar}>
                            Cancelar agendamento
                        </ApiButton>
                    ) : (
                        <p className={styles.avisoPrazoCancelar}>
                            🔒 Prazo para cancelar a refeição de hoje já expirou (até 07:59).
                        </p>
                    )}
                </div>
            ) : diaJaPassou() ? (
                <p className={styles.avisoPrazoCancelar}>
                    Este dia já passou, sem agendamento registrado.
                </p>
            ) : (
                <button
                    className={styles.btnAgendar}
                    onClick={() => {
                        if (!podeAgendar(diaSelecionado, tipo)) {
                            alert("Prazo para agendamento expirado")
                            return
                        }
                        setShowConfirm(true)
                    }}
                >
                    Agendar Refeição
                </button>
            )}

            {/* HISTÓRICO DO DIA - agendar/cancelar de novo apagava o rastro
                (DelRef é hard-delete); esse log vem da Web.refeicao_log,
                tabela própria (pedido do usuário, 2026-08-31 - antes usava
                MicLog, trocado por ser lento e não indexado). */}
            {logRef.length > 0 && (
                <div className={styles.card}>
                    <span className={styles.cardTitulo}>🕘 Histórico do dia</span>
                    <div className={styles.logLista}>
                        {logRef.map((item, i) => {
                            const cancelou = item.acao === "CANCELADA"
                            return (
                                <div key={i} className={styles.logItem}>
                                    <span>{cancelou ? "❌" : "✅"}</span>
                                    <span>{cancelou ? "Cancelada" : "Agendada"} em {item.datahora}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}

            {/* MODAL CONFIRMAÇÃO */}
            {showConfirm && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modalBox}>
                        <h3>Confirmar Agendamento</h3>
                        <p>
                            <strong>{diasSemana.find(d => d.id === diaSelecionado)?.nome}</strong>
                            {semanaSelecionada === "proxima" ? " (semana seguinte)" : ""} · {TIPO_LABEL[tipo]}
                        </p>
                        {prato && <p>Alteração: {prato}</p>}
                        <div className={styles.modalButtons}>
                            <button className={styles.btnCancelarModal} onClick={() => setShowConfirm(false)}>
                                Voltar
                            </button>
                            <ApiButton
                                className={styles.btnConfirmar}
                                onClick={() => { setShowConfirm(false); agendar() }}
                            >
                                Confirmar
                            </ApiButton>
                        </div>
                    </div>
                </div>
            )}

            <BottomNav />
        </div>
    )

}
